module.exports = __webpack_public_path__ + "img/img-etouka@2x.2412c309.png";